import React from 'react'
import Page_ from 'v5/client/CreateQuietSellerPage.bs'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'
import { withMainLayout } from '../../pagesComponents/MainApp'

const Page = requireAuthenticatedAgent(Page_)

function CreateQuietSellerPage() {
  return <Page />
}

CreateQuietSellerPage.getLayout = withMainLayout

export default CreateQuietSellerPage
